import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <i className="ri-emotion-sad-line text-5xl text-foreground-400 mb-4 block"></i>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-4">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}